<div class="u-flex-full">
  <label>{{value?.code}} </label>
  <button class="close" *ngIf="value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
    (click)="clearPayment()">
    <mat-icon>close</mat-icon>
  </button>

</div>